import { Injectable } from '@angular/core';
import '@rschedule/moment-date-adapter/setup';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';
// import moment = require('moment-recur');
@Injectable({
  providedIn: 'root'
})
export class PackageScheduleService {
  constructor(
    private http: HttpClient
  ) {}

  /** API CALLS */
  getAllPackages() {
    return this.http.get<ApiResponseModel>('/api/package').toPromise();
  }

  getPackageById(packageId) {
    return this.http.get<ApiResponseModel>('/api/package/' + packageId).toPromise();
  }

  getPackageAvailability(packageId) {
    return this.http.get<ApiResponseModel>('/api/availability_package/package/' + packageId).toPromise();
  }

  addAvailabilityInstance(id, active, date, extras?: any) {
    return this.http.post<ApiResponseModel>('/api/availability_package/package/' + id, {active, date, ...extras}).toPromise();
  }

  updateAvailabilityInstance(availabilityId, active) {
    return this.http.patch<ApiResponseModel>('/api/availability_package/' + availabilityId, { active }).toPromise();
  }

  deleteAvailabilityInstance(availabilityId) {
    return this.http.delete<ApiResponseModel>('/api/availability_package/' + availabilityId).toPromise();
  }

}
